import { fabric } from 'fabric';

type EmojiShortcut = {
  emoji: string;
  variants: string[];
};

const EMOJI_SHORTCUTS: EmojiShortcut[] = [
  { emoji: '🙂', variants: [':)', ':-)', '=)'] },
  { emoji: '😀', variants: [':D', ':-D', '=D'] },
  { emoji: '😉', variants: [';)', ';-)'] },
  { emoji: '🙁', variants: [':(', ':-(', '=('] },
  { emoji: '😢', variants: [":'(", ':"('] },
  { emoji: '😮', variants: [':O', ':-O', ':o', ':-o'] },
  { emoji: '😛', variants: [':P', ':-P', ':p', ':-p'] },
  { emoji: '😎', variants: ['B)', 'B-)', '8)', '8-)'] },
  { emoji: '😐', variants: [':|', ':-|'] },
  { emoji: '😡', variants: ['>:(', '>:-('] },
  { emoji: '🤯', variants: ['>.<'] },
  { emoji: '🤔', variants: [':?', ':-?'] },
  { emoji: '😇', variants: ['O:)', '0:)', 'O:-)', '0:-)'] },
  { emoji: '❤️', variants: ['<3'] },
];

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const convertEmoticonsToEmoji = (value: string): string => {
  if (!value) {
    return value;
  }

  let result = value;
  for (const shortcut of EMOJI_SHORTCUTS) {
    for (const variant of shortcut.variants) {
      const regex = new RegExp(escapeRegExp(variant), 'g');
      result = result.replace(regex, shortcut.emoji);
    }
  }
  return result;
};

export const attachEmojiShortcuts = (textObject: fabric.IText) => {
  const alreadyAttached = (textObject as any).__emojiShortcutsAttached;
  if (alreadyAttached) {
    return;
  }

  const handleChanged = () => {
    const currentText = textObject.text ?? '';
    const convertedText = convertEmoticonsToEmoji(currentText);

    if (currentText === convertedText) {
      return;
    }

    const selectionStart = textObject.selectionStart ?? currentText.length;
    const selectionEnd = textObject.selectionEnd ?? selectionStart;

    const beforeSelection = currentText.slice(0, selectionStart);
    const withinSelection = currentText.slice(selectionStart, selectionEnd);

    const convertedBefore = convertEmoticonsToEmoji(beforeSelection);
    const convertedWithin = convertEmoticonsToEmoji(withinSelection);

    const beforeDelta = convertedBefore.length - beforeSelection.length;

    textObject.set('text', convertedText);

    const newSelectionStart = selectionStart + beforeDelta;
    const newSelectionEnd = newSelectionStart + convertedWithin.length;

    textObject.selectionStart = newSelectionStart;
    textObject.selectionEnd = newSelectionEnd;

    textObject.canvas?.requestRenderAll();
  };

  const cleanup = () => {
    textObject.off('changed', handleChanged);
    textObject.off('removed', cleanup);
    (textObject as any).__emojiShortcutsAttached = false;
  };

  textObject.on('changed', handleChanged);
  textObject.on('removed', cleanup);
  (textObject as any).__emojiShortcutsAttached = true;
};


